import { Card, Link } from '@skf-internal/ui-components-react-legacy';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

interface LeftMenuProps {}

const LeftMenu = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const MASTER_DATA_TYPES = [
    { value: '/master-data/manufacturers', display: intl.formatMessage({ id: 'masterdata.menu.manufacturer' }) }
    // { value: '/master-data/bearing-types', display: intl.formatMessage({ id: 'masterdata.menu.bearingType' }) }
  ];

  return (
    <Card className="mb-5">
      <nav>
        <ul>
          {MASTER_DATA_TYPES.map((type) => (
            <li key={type.value}>
              <Link
                as="button"
                onClick={() => navigate(type.value)}
                className={`w-full text-left px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 ${location.pathname === type.value ? 'bg-gray-200 font-bold' : 'hover:bg-gray-100'}`}
              >
                {type.display}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </Card>
  );
};

export default LeftMenu;
